import React from 'react'
import './landing-scroll.css'

export default function LandingScrollBranding() {
   return (
<div className="bg-gray-100">
         <section class="landing-scroll-branding">
              
            <div class="scroll Developers  alt">
               <div>
                  <span>Designers </span> <span class="filled">Developers </span>
                  <span>Programmers </span> <span>Creators </span>
                  <span>Enthusiasts </span> <span>Designers </span>
                  <span class="filled">Developers </span> <span>Programmers </span>
                  <span>Creators </span> <span>Enthusiasts </span>
               </div>
               <div>
                  <span>Designers </span> <span class="filled">Developers </span>
                  <span>Programmers </span> <span>Creators </span>
                  <span>Enthusiasts </span> <span>Designers </span>
                  <span class="filled">Developers </span> <span>Programmers </span>
                  <span>Creators </span> <span>Enthusiasts </span>
               </div>
            </div>
           
         </section>
      </div>
   )
}